<template>
    <a href="#" @click="visible = true" v-if="showButton" class="mx-1 p-button  p-button-icon-only p-button-secondary p-button-rounded p-button-text  ">
        <i class="pi pi-check"></i>
    </a>

    <Dialog v-model:visible="visible" modal :header="title" :style="{ width: '25rem' }">
        
        <div class="flex items-center gap-4 mb-4">
            <label for="username" class="font-semibold w-24">{{ dateText }}</label>
            <DatePicker v-model="date" class="flex-auto" dateFormat="dd/mm/yy" showIcon fluid :minDate="minDate" :maxDate="maxDate" :manualInput="false"/>

        </div>
        <div class="flex justify-end gap-2">
            <Button type="button" :label="cancelText" severity="secondary" @click="visible = false"></Button>
            <Button type="button" :label="confirmText" @click="inviaConferma()"></Button>
        </div>
    </Dialog>
</template>
  
  <script>
  
  import Dialog from 'primevue/dialog';
  import Button from 'primevue/button';
  import InputText from 'primevue/inputtext';
  import DatePicker from 'primevue/datepicker';


  
  export default {
    name: "ConfirmTicket",
    components: {
        InputText,
		Dialog,
        DatePicker,
		Button,
	},
    props: ['action','id','stato', 'title' , 'dateText','confirmText','cancelText', 'can_confirm','is_dispatcher'],
    data() {
      return {
        visible: false,
        action: this.action,
        id: this.id,
        stato: this.stato,
        dispatcher: this.is_dispatcher,
        showButton: false,
        date: null,
        minDate: null,
        maxDate: new Date(),
        title: this.title,
        dateText: this.dateText,
        confirmText: this.confirmText,
        cancelText: this.cancelText,
      };
    },
    created(){
        let date = new Date();
        if(date.getDate() <= 3){
            date.setDate(1)
            date.setDate(-3)
        }else{
            date.setDate(1)
        }
        console.log(date);
        this.minDate = date;
    },
    mounted() {
        if(this.stato[0].props.severity == "success" && this.dispatcher ){
            this.showButton = true;
        }

       
    },
    methods: {
        async inviaConferma(){
            console.log("Invio Conferma");
            console.log(this.date);
            // qui faccio la chiamata axios per inviare la conferma

            await axios.post(route(this.action,{id:this.id}),{data_chiusura:this.date}).then((res)=>{
                window.location.reload();
            })
        }
    }
  }
  </script>
  
  <style scoped>
  
  </style>